module.exports = __webpack_public_path__ + "static/media/hleft.2641fa69.png";